import { useEffect, useRef } from 'react'
import recordPCEvent from 'core/utils/RecordEvent/recordPCEvent'

type TGoogleLoginProps = {
  clientId: string
  className?: string
  handleCredentialResponse: (response: any) => void
  config?: Record<string, any>
  children?: React.ReactNode
}
let googleScript: HTMLScriptElement | null = null
export default function GoogleLogin(props: TGoogleLoginProps) {
  const boxRef = useRef<HTMLDivElement>(null)
  useEffect(() => {
    if (!googleScript && typeof window !== 'undefined') {
      const googleScript = document.createElement('script')
      googleScript.async = true
      googleScript.src = 'https://accounts.google.com/gsi/client'

      googleScript.onload = () => {
        // 初始化谷歌登录
        window.google.accounts.id.initialize({
          client_id: props.clientId,
          callback: props.handleCredentialResponse,
          ux_mode: 'popup',
        })

        //一键式提醒登录框
        window.google.accounts.id.renderButton(boxRef.current, {
          theme: 'outline',
          size: 'large',
          shape: 'circular',
          ...props.config,
          // locale: "zh_CN",
          click_listener: () => {
            recordPCEvent.record('Home_HeroImage_Google')
          },
        })
      }
      document.head.appendChild(googleScript)
    }
  }, [])
  return (
    <div
      style={{
        position: 'relative',
        overflow: 'hidden',
      }}
      className={props.className}
    >
      {props.children}
      <div ref={boxRef} style={{ opacity: 0.01, position: 'absolute', top: 0, transform: 'scale(3)' }} />
    </div>
  )
}
